module.exports = __webpack_public_path__ + "img/bookmark_grey_outline.efb3eeb7.png";